import React, { useEffect, useState } from 'react';
import { cilQrCode } from '@coreui/icons';
import CIcon from '@coreui/icons-react'
import { useKeycloak } from "@react-keycloak/web";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Typography
} from '@mui/material';
import {
  CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CDropdownToggle, CDropdown, CDropdownItem, CDropdownMenu
} from '@coreui/react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { asaApiClient } from 'src/network/AsaApiclient';
import { groupEndPoints } from 'src/repositories/endPoints';
import { groupsRepository } from 'src/repositories/GroupsRepository';



const Groups = () => {
  const [qrCodeData, setQrCodeData] = useState([]);
  const [selectedQrCode, setSelectedQrCode] = useState(null);
  const [isQrCodeModalOpen, setIsQrCodeModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [selectedChannel, setSelectedChannel] = useState('');
  const [qrCodeText, setQrCodeText] = useState('');
  const [knowledgeUrls, setKnowledgeUrls] = useState('');
  const [selectedKnowledgeUrl, setSelectedKnowledgeUrl] = useState('');

  const { keycloak } = useKeycloak();

  const fetchQrCodeData = async () => {
    try {
      const response = await asaApiClient.get(groupEndPoints.getQrCodeList());

      if (Array.isArray(response.data)) {
        setQrCodeData(response.data);
      } else {
        console.error('API response is not an array:', response.data);
      }
    } catch (error) {
      console.error('Error fetching QR code data:', error);
    }
  };
  useEffect(() => {

    const fetchKnowledgeUrls = async () => {
      try {
        const response = await asaApiClient.get(groupEndPoints.getKnowledgeUrls());
        if (Array.isArray(response.knowledge_urls)) {
          setKnowledgeUrls(response.knowledge_urls);
          const formattedUrls = response.knowledge_urls.map(item => {
            return {
              dropdown_url: `${item.instance_name.replace(/_/g, ' ').toUpperCase()} : ${item.curate_url}`,
              curate_url: `${item.curate_url}`,
              deployment_id: `${item.deployement_id}`,
              instance_url: `${item.instance_url}`
            };
          });
          setKnowledgeUrls(formattedUrls); // Filter out null values
        } else {
          console.error('API response is not an array:', response);
        }
      } catch (error) {
        console.error('Error fetching knowledge urls:', error);
      }
    }
    fetchKnowledgeUrls();
    fetchQrCodeData();

  }, []);

  const getKnowledgeUrlGroups = (url, deploymentId) => {
    groupsRepository.getKnowledgeUrlGroups({ knowledgeUrl: url, deploymentId: deploymentId })
      .then((response) => {
        setGroups(response);
      })
      .catch(error => {
        console.error('Failed to update project:', error);
      });
  }
  const handleQrClick = (item) => {
    console.log('QR code URL:', item);
    setSelectedQrCode(item);
    setIsQrCodeModalOpen(true);  // Open the QR code modal when clicked
  };

  const closeQrCodeModal = () => {
    setSelectedKnowledgeUrl('');
    setSelectedGroup('');
    setSelectedChannel('');
    setQrCodeText('');
    setSelectedQrCode(null);
    setIsQrCodeModalOpen(false);  // Close the QR code modal
  };

  const openCreateModal = () => {
    setIsCreateModalOpen(true);
  };

  const closeCreateModal = () => {
    setIsCreateModalOpen(false);
    setSelectedKnowledgeUrl('');
    setSelectedGroup('');
    setSelectedChannel('');
    setQrCodeText('');
  };

  const handleCreateQrCode = async () => {
    try {
      const response = await asaApiClient.post(groupEndPoints.generateQrCode(), {
        groupName: selectedGroup,
        channelName: selectedChannel,
        userId: keycloak.tokenParsed.sub,
        qrCodeText: qrCodeText,
        knowledgeUrl: selectedKnowledgeUrl.curate_url,
        deploymentId: selectedKnowledgeUrl.deployment_id
      });
      if (response.success) {
        await fetchQrCodeData();
        closeCreateModal();
        toast.success('QR code generation successful!');
      } else if (response.error) {
        toast.error('QR code text already exists. Please try with different text.');
      } else {
        console.error('Error generating QR code:', response.data);
        toast.error('QR code not generated.');
      }
    } catch (error) {
      console.error('Error generating QR code:', error);
      toast.error('QR code not generated.');
    }
  };
  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', padding: '10px', borderRadius: '5px' }}>
        <Typography variant="h4" sx={{ color: '#1a1a1a' }}>QRCodes</Typography>
        <Button
          onClick={openCreateModal}
          sx={{ backgroundColor: '#fcaf17', color: '#000', fontWeight: "bold", padding: '5px 10px', borderRadius: '6px', '&:hover': { backgroundColor: '#fcaf17' } }}
        >
          + Create QRCode
        </Button>
      </div>

      <TableContainer component={Paper} sx={{ backgroundColor: '#252525' }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ color: '#fff', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>SL No</TableCell>
              <TableCell sx={{ color: '#fff', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>Group Name</TableCell>
              <TableCell sx={{ color: '#fff', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>Channel Name</TableCell>
              <TableCell sx={{ color: '#fff', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>Instance URL</TableCell>
              <TableCell sx={{ color: '#fff', borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>QR Code</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {qrCodeData.length > 0 && qrCodeData.map((item, index) => (
              <TableRow key={index}>
                <TableCell sx={{ color: '#fff', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>{index + 1}</TableCell>
                <TableCell sx={{ color: '#fff', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>{item.group_name}</TableCell>
                <TableCell sx={{ color: '#fff', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>{item.channel_name}</TableCell>
                <TableCell sx={{ color: '#fff', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>{item.curate_url}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>
                  <Button
                    onClick={() => handleQrClick(item)}
                    sx={{ color: '#fff', background: 'none', '&:hover': { backgroundColor: '#444' } }}
                  >
                    <CIcon icon={cilQrCode} size="lg" />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>


      {isCreateModalOpen && selectedQrCode && (
        <CModal visible onClose={closeCreateModal} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
          <CModalBody
            sx={{
              backgroundColor: '#252525',
              padding: '30px',
              borderRadius: '8px',
              textAlign: 'center',
              width: '300px',
              maxWidth: '90%',
              position: 'relative'
            }}
          >
            <Button
              onClick={closeCreateModal}
              sx={{
                position: 'absolute',
                top: '10px',
                right: '15px',
                fontSize: '1.5rem',
                color: '#fff',
                cursor: 'pointer',
                background: 'none',
                border: 'none'
              }}
            >
              &times;
            </Button>

            {/* Heading */}
            <Typography variant="h6" sx={{ color: '#fff', fontSize: '20px', marginBottom: '20px' }}>Create QR Code</Typography>

            <label className="form-label">Select Instance URL:</label><br />
            <CDropdown direction="center" style={{ width: '100%' }}>
              <CDropdownToggle color="secondary" className="flexGap5 dropdown-toggle-fixed" style={{ justifyContent: selectedKnowledgeUrl ? 'space-between' : 'end', border: '1px solid var(--active) !important' }}>
                <span className="dropdown-text">
                  {selectedKnowledgeUrl.dropdown_url}</span><span>▼</span>
              </CDropdownToggle>
              <CDropdownMenu style={{ width: '100%' }}>
                {Array.isArray(knowledgeUrls) && knowledgeUrls.map((url, index) => {
                  return (
                    <CDropdownItem key={index} onClick={() => {
                      setSelectedGroup('');
                      setSelectedChannel('');
                      getKnowledgeUrlGroups(url.curate_url); // Pass only curate_url
                      setSelectedKnowledgeUrl(url);
                    }}>
                      {url.dropdown_url}
                    </CDropdownItem>
                  );
                })}
              </CDropdownMenu>
            </CDropdown>

            {selectedKnowledgeUrl && (
              <>

                {/* <FormControl fullWidth sx={{ marginBottom: '16px' }}> */}
                <label className="form-label mt-4">Select Group:</label><br />
                <CDropdown direction="center" style={{ width: '100%' }}>
                  <CDropdownToggle color="secondary" className="flexGap5 dropdown-toggle-fixed" style={{ justifyContent: selectedGroup ? 'space-between' : 'end', border: '1px solid var(--active) !important' }}>
                    <span className='dropdown-text'>{selectedGroup}</span>
                    <span>▼</span>
                    {/* <CIcon icon={cilChevronBottom} style={{ cursor: 'pointer' }} /> */}
                  </CDropdownToggle>
                  <CDropdownMenu style={{ width: '100%' }}>
                    {/* <CDropdownItem value="">Select a group</CDropdownItem> */}
                    {groups.map((group, index) => (
                      <CDropdownItem key={index} onClick={() => { setSelectedGroup(group.group_name); setSelectedChannel(''); }}>
                        {group.group_name}
                      </CDropdownItem>
                    ))}
                  </CDropdownMenu>
                </CDropdown>
                {/* <Select
              value={selectedGroup}
              onChange={(e) => { setSelectedGroup(e.target.value); setSelectedChannel(''); }}
              sx={{
                backgroundColor: '#333',
                color: '#fff',
                padding: '8px',
                borderRadius: '5px',
                '& .MuiSelect-select': { padding: '5px' }
              }}
            >
              <MenuItem value="">Select a group</MenuItem>
              {groups.map((group, index) => (
                <MenuItem key={index} value={group.group_name}>{group.group_name}</MenuItem>
              ))}
            </Select> */}
                {/* </FormControl> */}

                {/* <FormControl fullWidth> */}
                <label className="form-label mt-4">Select Channel:</label><br />

                {/* <Select
              value={selectedChannel}
              onChange={(e) => setSelectedChannel(e.target.value)}
              sx={{
                backgroundColor: '#333',
                color: '#fff',
                padding: '8px',
                borderRadius: '5px',
                '& .MuiSelect-select': { padding: '5px' }
              }}
            >
              <MenuItem value="">Select a channel</MenuItem>
              <MenuItem value="all">All</MenuItem>
              {selectedGroup && groups.find(group => group.group_name === selectedGroup)?.channel.map((channel, index) => (
                <MenuItem key={index} value={channel}>{channel}</MenuItem>
              ))}
            </Select> */}
                <CDropdown direction="center" style={{ width: '100%' }}>
                  <CDropdownToggle color="secondary" className="flexGap5 dropdown-toggle-fixed" style={{ justifyContent: selectedChannel ? 'space-between' : 'end', border: '1px solid var(--active) !important' }}>
                    <span className='dropdown-text'>{selectedChannel}</span>
                    <span>▼</span>
                    {/* <CIcon icon={cilChevronBottom} style={{ cursor: 'pointer' }} /> */}
                  </CDropdownToggle>
                  <CDropdownMenu style={{ width: '100%' }}>
                    {/* <CDropdownItem value="">Please select channel</CDropdownItem> */}
                    <CDropdownItem value="all" onClick={() => setSelectedChannel("all")}>All</CDropdownItem>
                    {selectedGroup && groups.find(group => group.group_name === selectedGroup)?.channel.map((channel, index) => (
                      <CDropdownItem key={index} onClick={() => setSelectedChannel(channel)}>
                        {channel}
                      </CDropdownItem>
                    ))}
                  </CDropdownMenu>
                </CDropdown>
              </>
            )}

            <label className="form-label mt-4">Enter QR Code Text:</label><br />
            <textarea
              value={qrCodeText}
              onChange={(e) => setQrCodeText(e.target.value)}
              placeholder="Enter text for QR code"
              style={{
                width: '100%',
                height: '80px',
                backgroundColor: '#333',
                color: '#fff',
                padding: '10px',
                borderRadius: '5px',
                border: '1px solid #444',
                marginBottom: '20px',
                borderColor: '#fcaf17'
              }}
            />
            {/* </FormControl> */}

          </CModalBody>

          <CModalFooter sx={{ backgroundColor: '#252525', padding: '10px' }}>
            <Button
              onClick={handleCreateQrCode}
              sx={{
                backgroundColor: '#fcaf17',
                color: '#000',
                padding: '10px 15px',
                borderRadius: '4px',
                fontSize: '16px',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
                '&:hover': {
                  backgroundColor: '#fcaf17'
                }
              }}
            >
              Create QR Code
            </Button>
          </CModalFooter>
        </CModal>
      )}
      {isQrCodeModalOpen && (
        <CModal visible={isQrCodeModalOpen} onClose={closeQrCodeModal}>
          <CModalHeader>
            <CModalTitle sx={{ color: '#fff' }}>QR Code</CModalTitle>
          </CModalHeader>
          <CModalBody sx={{ textAlign: 'center', padding: '20px' }}>
            <Typography variant="h6" sx={{ color: '#fff', marginBottom: '10px', fontSize: '1.1rem' }}>
              Please scan this QR code to proceed with WhatsApp chat
            </Typography>
            <a target="_blank" rel="noopener noreferrer" style={{ color: '#fcaf17' }} href={`https://wa.me/+917483950284?text=${selectedQrCode.qrcode_text}`}> https://wa.me/+917483950284?text={selectedQrCode.qrcode_text}</a>
            <img src={selectedQrCode.qrcode_s3_url} alt="QR Code" style={{ width: '100%', height: '100%', objectFit: 'contain', marginBottom: '10px' }} />
          </CModalBody>
          <CModalFooter>
            <Button onClick={closeQrCodeModal} sx={{ backgroundColor: ' #fcaf17', color: '#000' }}>
              Close
            </Button>
          </CModalFooter>
        </CModal>
      )}
    </div>
  );
};

export default Groups;

